export default __webpack_public_path__ + "static/logo-white-79aeaf1dcc863548b655826d694ee8e3.png";